// Module
var code = "<cr-experience-flyout data=\"flyoutData\"></cr-experience-flyout> ";
// Exports
export default code;